import { Button, Dialog, DialogActions, Box, DialogContent, TextField, IconButton, DialogTitle, Typography, FormHelperText, Select, MenuItem } from '@mui/material';
import { setSuccessfullModifyDialog } from '../../../redux/successfullModifyDialogSlice';
import { CustomErrorLogger } from '../../../utils/CustomErrorLogger';
import { useCallback, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import Iconify from '../../Iconify';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import '../../../css/machines/addMachineNote.css';

const TYPE_OPTIONS = [
    { value: 'Securite', labelKey: 'Sécurité' },
    { value: 'Maintenance', labelKey: 'Maintenance' },
    { value: 'Information', labelKey: 'Information' },
    { value: 'Autre', labelKey: 'Autre' },
];

export const AddMachineAnonymousNote = ({ openAddNote, setOpenAddNote }) => {

    const { token } = useParams();
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const [errMsg, setErrMsg] = useState(null);

    const formik = useFormik({
        initialValues: {
            token: token || '',
            name: '',
            email: '',
            type: 'Information',
            message: ''
        },
        validateOnBlur: true,
        validateOnChange: true,
        validationSchema: Yup.object().shape({
            token: Yup.string().required(t('isRequired')),
            name: Yup.string().required(t('isRequired')),
            email: Yup.string().email(t('emailFormatRequired')).optional(),
            type: Yup.string().required(t('isRequired')),
            message: Yup.string().required(t('isRequired')),
        }),
        onSubmit: async (values) => {
            try {
                const { status } = await axios.post('machine-note/anonymous', values);
                if (status === 200 || status === 201 || status === 202 || status === 204) {
                    setOpenAddNote(false);
                    dispatch(setSuccessfullModifyDialog({ open: true, type: 'Ajouter la remarque de la machine' }));
                }
            } catch (error) {
                setErrMsg(error?.message);
                console.error('Error add machine anonymous note:', error);
                CustomErrorLogger(error, "error add machine anonymous note");
            }
        },
    });

    const { handleSubmit, values, touched, errors, handleChange, handleBlur } = formik;

    const handleClose = useCallback(() => {
        setOpenAddNote(false);
    }, [setOpenAddNote]);

    return (
        <Dialog open={openAddNote} fullWidth maxWidth='md'>
            <IconButton onClick={handleClose} className='addMachineNote_icon_button'>
                <Iconify icon="material-symbols:close" className='addMachineNote_close_icon' />
            </IconButton>
            <DialogTitle className='addMachineNote_dialog_title'>Ajouter une remarque</DialogTitle>
            <form onSubmit={handleSubmit}>
                {errMsg && <Typography className='errMsg'>{errMsg}</Typography>}
                <DialogContent className='addMachineNote_dialog_content'>
                    <Box className="addMachineNote_helper_selct_box">
                        <FormHelperText id="outlined-weight-helper-text" className="addMachineNoteInputTitle">Type</FormHelperText>
                        <Select
                            className="addMachineNote_select_metier"
                            name="type"
                            fullWidth
                            value={values.type}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.type && Boolean(errors.type)}
                            displayEmpty
                            inputProps={{ 'aria-describedby': 'outlined-weight-helper-text' }}
                        >
                            {TYPE_OPTIONS.map(opt => (
                                <MenuItem key={opt.value} value={opt.value}>{t(opt.labelKey)}</MenuItem>
                            ))}
                        </Select>
                        {touched.type && errors.type && (
                            <FormHelperText error className='addMachineNote_err_helper_select'>{errors.type}</FormHelperText>
                        )}
                    </Box>
                    <Box className="addMachineNote_helper_selct_box">
                        <FormHelperText id="addMachineAnoninusNoteName" className="addMachineNoteInputTitle">Nom</FormHelperText>
                        <TextField
                            id="addMachineAnoninusNoteName"
                            className='addUser_InputField'
                            name="name"
                            fullWidth
                            value={values.name}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.name && Boolean(errors.name)}
                            helperText={touched.name && errors.name}
                        />
                    </Box>
                    <Box className="addMachineNote_helper_selct_box">
                        <FormHelperText id="addMachineAnoninusNoteEmail" className="addMachineNoteInputTitle">{t('adressEmail')} (optionnel)</FormHelperText>
                        <TextField
                            id="addMachineAnoninusNoteEmail"
                            className='addUser_InputField'
                            name="email"
                            fullWidth
                            value={values.email}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={touched.email && Boolean(errors.email)}
                            helperText={touched.email && errors.email}
                        />
                    </Box>
                    <Box className="addMachineNote_helper_selct_box">
                        <FormHelperText id="addMachineAnoninusNoteMessage" className="addMachineNoteInputTitle">Message</FormHelperText>
                        <TextField
                            id="addMachineAnoninusNoteMessage"
                            className='addMachineNote_InputField'
                            name="message"
                            fullWidth
                            value={values.message}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            multiline
                            rows={6}
                            error={touched.message && Boolean(errors.message)}
                            helperText={touched.message && errors.message}
                        />
                    </Box>
                </DialogContent>
                <DialogActions className='addMachineNote_dialog_actions'>
                    <Button className='addMachineNote_button_annuler' onClick={handleClose}>{t('Annuler')}</Button>
                    <Button className='addMachineNote_button_valider' variant="contained" type="submit">{t('Valider')}</Button>
                </DialogActions>
            </form>
        </Dialog>
    );
};